<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  overflow: hidden;
  width: 100%;
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}

/* 全局响应式样式 - 将所有固定宽度改为最小宽度 */
.el-table {
  min-width: 600px;
}

.el-table .el-table-column {
  min-width: auto;
}

/* 确保所有页面容器都是响应式的 */
.el-card {
  width: 100%;
  min-width: 0;
}

.el-card__body {
  width: 100%;
  min-width: 0;
  overflow-x: auto;
}

/* 响应式输入框 */
.el-input {
  min-width: 0;
}

/* 响应式选择器 */
.el-select {
  min-width: 0;
}

/* 响应式日期选择器 */
.el-date-editor {
  min-width: 0;
}

/* 确保表格可以横向滚动 */
.el-table__body-wrapper {
  overflow-x: auto;
}

/* 响应式分页 */
.el-pagination {
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .el-pagination {
    justify-content: center;
  }
  
  .el-pagination .el-pagination__sizes,
  .el-pagination .el-pagination__jump {
    margin-top: 10px;
  }
}
</style>

